import { useEffect, useState } from 'react';

import { Alert, Box, Button, MenuItem, Stack, TextField, Typography } from '@mui/material';

import CRUDs from '../../../../api/CRUDs';

const api = CRUDs.perfisPermissao;

const verdadeiro = (v) => v === true || v === 1 || v === '1' || v === 'true';

const mensagem = (e) => e?.response?.data?.message || e?.message || 'Não foi possível concluir a operação.';

export default function PessoaPerfisAcesso(props) {

    // Trocar de pessoa desmonta as consultas e seleções anteriores.

    return <SelecaoEmpresa key={props.pessoa?.id || 'novo'} {...props} />;

}

function SelecaoEmpresa({ pessoa, pessoaEmpresas = [], empresaIds = [], empresaIdAtual }) {

    const [empresas, setEmpresas] = useState([]);

    const [empresaId, setEmpresaId] = useState('');

    const [erro, setErro] = useState('');

    const [loading, setLoading] = useState(true);

    const [busy, setBusy] = useState(false);

    const [reload, setReload] = useState(0);

    const pessoaId = pessoa?.id;

    useEffect(() => {

        if (!pessoaId) {

            setLoading(false);

            return;

        }

        let vigente = true;

        setLoading(true);

        setErro('');

        api.catalogo()

            .then(({ data }) => {

                if (vigente) setEmpresas(data.data.empresas);

            })

            .catch((e) => {

                if (vigente) setErro(mensagem(e));

            })

            .finally(() => {

                if (vigente) setLoading(false);

            });

        return () => {

            vigente = false;

        };

    }, [pessoaId, reload]);

    const vinculadas = new Set(

        [pessoa?.empresaId, ...(pessoaEmpresas || []).filter((e) => verdadeiro(e.ativo) && !e.deletedAt).map((e) => e.empresaId)]

            .filter(Boolean)

            .map(String)

    );

    const escopo = new Set(

        (Array.isArray(empresaIds) && empresaIds.length ? empresaIds : [empresaIdAtual]).filter(Boolean).map(String)

    );

    const interno = localStorage.getItem('isAdmin') === 'true';

    const permitidas = empresas.filter((e) => vinculadas.has(String(e.id)) && (interno || escopo.has(String(e.id))));

    const ids = permitidas.map((e) => String(e.id)).join(',');

    useEffect(() => {

        const opcoes = ids ? ids.split(',') : [];

        setEmpresaId((prev) =>

            opcoes.includes(prev) ? prev : opcoes.includes(String(empresaIdAtual)) ? String(empresaIdAtual) : opcoes[0] || ''

        );

    }, [ids, empresaIdAtual]);

    const empresa = permitidas.find((e) => String(e.id) === empresaId);

    return (

        <Box sx={{ mt: 3, borderTop: 1, borderColor: 'divider', pt: 2 }}>

            <Typography variant="h6">Perfil de acesso por empresa</Typography>

            <Typography variant="body2" sx={{ mb: 2 }}>

                Salve o usuário e os vínculos de empresa antes de aplicar o perfil. Aplicar perfil é uma operação separada do

                botão Salvar.

            </Typography>

            {!pessoaId ? (

                <Alert severity="info">Salve a pessoa para associar um perfil.</Alert>

            ) : (

                <Stack spacing={2}>

                    {erro && (

                        <Alert

                            severity="error"

                            action={

                                <Button type="button" onClick={() => setReload((r) => r + 1)}>

                                    Tentar novamente

                                </Button>

                            }

                        >

                            {erro}

                        </Alert>

                    )}

                    {loading && <Typography>Carregando empresas…</Typography>}

                    <TextField

                        select

                        label="Empresa"

                        value={empresa ? empresaId : ''}

                        disabled={loading || busy || !!erro}

                        onChange={(e) => setEmpresaId(e.target.value)}

                    >

                        <MenuItem value="">Selecione</MenuItem>

                        {permitidas.map((e) => (

                            <MenuItem key={e.id} value={String(e.id)}>

                                {e.nomeFantasia || e.id}

                            </MenuItem>

                        ))}

                    </TextField>

                    {!loading && !erro && !permitidas.length && (

                        <Alert severity="info">Nenhuma empresa vinculada disponível no seu acesso atual.</Alert>

                    )}

                    {empresa && !erro && (

                        <Vinculo key={`${pessoaId}:${empresaId}`} pessoa={pessoa} empresa={empresa} setBusyPai={setBusy} />

                    )}

                </Stack>

            )}

        </Box>

    );

}

function Vinculo({ pessoa, empresa, setBusyPai }) {

    const [perfis, setPerfis] = useState([]);

    const [perfilId, setPerfilId] = useState('');

    const [vinculo, setVinculo] = useState(null);

    const [loading, setLoading] = useState(true);

    const [busy, setBusy] = useState(false);

    const [erro, setErro] = useState('');

    const [sucesso, setSucesso] = useState('');

    const [reload, setReload] = useState(0);

    const pessoaId = pessoa.id;

    const empresaId = empresa.id;

    useEffect(() => {

        let vigente = true;

        setLoading(true);

        setErro('');

        Promise.all([api.listar(empresaId), api.vinculo(empresaId, pessoaId)])

            .then(([p, v]) => {

                if (!vigente) return;

                const lista = p.data.data.filter((item) => verdadeiro(item.ativo));

                setPerfis(lista);

                setVinculo(v.data.data);

                const atual = v.data.data?.perfilPermissaoId;

                setPerfilId(lista.some((item) => String(item.id) === String(atual)) ? String(atual) : '');

            })

            .catch((e) => {

                if (vigente) setErro(mensagem(e));

            })

            .finally(() => {

                if (vigente) setLoading(false);

            });

        return () => {

            vigente = false;

        };

    }, [empresaId, pessoaId, reload]);

    async function executar(aplicar) {

        setBusy(true);

        setBusyPai(true);

        setErro('');

        setSucesso('');

        try {

            if (aplicar) {

                const { data } = await api.consultar(empresaId, perfilId);

                const perfil = data.data;

                if (

                    !window.confirm(

                        `Aplicar ${perfil.descricao} a ${pessoa.nomePrincipal || pessoaId} em ${empresa.nomeFantasia || empresaId}?\nAs permissões nessa empresa serão substituídas.${!perfil.itens.length ? '\nPerfil vazio: todos os acessos dessa empresa serão revogados.' : ''}`

                    )

                )

                    return;

                const r = await api.aplicar({

                    empresaId,

                    pessoaId,

                    perfilPermissaoId: Number(perfilId),

                    confirmarPerfilVazio: !perfil.itens.length,

                });

                setSucesso(r.data.message || 'Perfil aplicado.');

            } else {

                if (!window.confirm('Desvincular o perfil e manter as permissões atuais para personalização?')) return;

                const r = await api.desvincular({ empresaId, pessoaId });

                setSucesso(r.data.message || 'Perfil desvinculado.');

            }

            setReload((r) => r + 1);

        } catch (e) {

            setErro(mensagem(e));

        } finally {

            setBusy(false);

            setBusyPai(false);

        }

    }

    return (

        <Stack spacing={2}>

            {erro && <Alert severity="error">{erro}</Alert>}

            {sucesso && <Alert severity="success">{sucesso}</Alert>}

            <Typography variant="body2">

                {loading

                    ? 'Consultando perfil…'

                    : erro

                      ? 'Atualize a consulta antes de continuar.'

                      : vinculo

                        ? `Perfil atual: ${vinculo.perfilPermissao?.descricao || vinculo.perfilPermissaoId}`

                        : 'Permissões individuais — nenhum perfil associado.'}

            </Typography>

            <TextField

                select

                label="Perfil"

                value={perfilId}

                disabled={loading || busy || !!erro}

                onChange={(e) => setPerfilId(e.target.value)}

            >

                <MenuItem value="">Selecione</MenuItem>

                {perfis.map((p) => (

                    <MenuItem key={p.id} value={String(p.id)}>

                        {p.descricao}

                    </MenuItem>

                ))}

            </TextField>

            <Stack direction="row" spacing={1} flexWrap="wrap">

                <Button

                    type="button"

                    variant="contained"

                    disabled={loading || busy || !!erro || !perfilId}

                    onClick={() => executar(true)}

                >

                    Aplicar perfil

                </Button>

                <Button type="button" disabled={loading || busy || !!erro || !vinculo} onClick={() => executar(false)}>

                    Desvincular e personalizar

                </Button>

                <Button type="button" disabled={loading || busy} onClick={() => setReload((r) => r + 1)}>

                    Atualizar

                </Button>

            </Stack>

        </Stack>

    );

}
